// extracted by mini-css-extract-plugin
module.exports = {"chip":"chip_chip__kguDW","chip--selected":"chip_chip--selected__1vWrV","text":"chip_text__Kp3zK"};